import React, { useContext } from 'react'
import { Box, useTheme } from '@mui/material'
import { isBooked, isSeatInBasket, isSelectedByMe } from '../../utils/util'
import { ReservationContext } from '../../context/ReservationContext'
import PropTypes from 'prop-types'

export default function Seat({ seat, onClick, sessionUUID, allowClickOnOccupied = false }) {
  const theme = useTheme()

  const { selectedSeats } = useContext(ReservationContext)

  const getColor = () => {
    if (seat.status === 'available') return theme.palette.seat.available
    if (isBooked(seat, sessionUUID, selectedSeats)) return theme.palette.seat.occupied
    if (isSelectedByMe(seat, sessionUUID) && !isSeatInBasket(seat, selectedSeats)) {
      // from a previous "confirm" of the same session, removed from basket,
      // but not yet deleted from DB
      return theme.palette.seat.available
    }
    return theme.palette.seat.selected
  }

  return (
    <Box
      data-testid={`seat-${seat.id}`}
      onClick={!isBooked(seat, sessionUUID, selectedSeats) || allowClickOnOccupied ? onClick : undefined}
      style={{
        margin: '5px',
        cursor: isBooked(seat, sessionUUID, selectedSeats) && !allowClickOnOccupied ? 'not-allowed' : 'pointer',
        textAlign: 'center',
        fontSize: '10px'
      }}
    >
      <Box
        sx={{
          width: { xs: '12px', md: '30px' },
          height: { xs: '12px', md: '30px' }
        }}
      >
        {/* SVG siège */}
        <svg
          viewBox='0 0 24 24'
          fill={getColor()}
          style={{
            transformOrigin: 'center bottom',
            color: theme.palette.text.secondary
          }}
        >
          <g transform='rotate(180 12 12)'>
            <path d='M6 10v6h2v4h8v-4h2v-6c0-2-1-3-3-3h-6c-2 0-3 1-3 3z' />
            <path d='M4 10h2v6H4zm14 0h2v6h-2z' />
          </g>
          <text x='12' y='15' textAnchor='middle' fontSize='6' fill='black' fontWeight='bold'>
            {seat.seat}
          </text>
        </svg>
      </Box>
    </Box>
  )
}

Seat.propTypes = {
  seat: PropTypes.shape({
    status: PropTypes.string.isRequired,
    seat: PropTypes.number.isRequired,
    row: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  sessionUUID: PropTypes.string,
  allowClickOnOccupied: PropTypes.bool
}
